<div class="task__sidenav__blue">
  <div
    [formGroup]="service.form"
    *ngIf="(service.isPreview && !!service.task) || service.isCreation || (service.isEdit && !!service.task)"
  >
    <task-sidenav-blue-preview *ngIf="service.isPreview" />
    <task-sidenav-blue-create *ngIf="!service.isPreview" />

    <div *ngIf="service.isConfigChange" class="task-priority-selector mt-3">
      <div class="new-select-label">{{ 'MyWork.Card.priorityLabel' | translate }}</div>
      <ng-select
        class="new-select w-100"
        [searchable]="false"
        [clearable]="false"
        [readonly]="!!service.task?.isDeleted"
        [formControlName]="service.TASK_SIDENAV_FORM.priority"
      >
        <ng-option [value]="1">{{ 'MyWork.Card.priority.sofort' | translate }}</ng-option>
        <ng-option [value]="2">{{ 'MyWork.Card.priority.dringend' | translate }}</ng-option>
        <ng-option [value]="3">{{ 'MyWork.Card.priority.wichtig' | translate }}</ng-option>
        <ng-option [value]="4">{{ 'MyWork.Card.priority.none' | translate }}</ng-option>
      </ng-select>
    </div>

    <div class="toggles mb-2 mt-3">
      <div *ngIf="service.isTaskSelection">
        <new-toggle-checkbox-v2
          [label]="'Projects.showOnCalendar' | translate"
          [formControlName]="service.TASK_SIDENAV_FORM.showInCalendar"
          [disabled]="service.task?.isDeleted || service?.task?.showInCalendar"
        />
      </div>

      <new-toggle-checkbox-v2
        [label]="'ProjectTasks.Task.hiddenFromClient' | translate"
        [formControlName]="service.TASK_SIDENAV_FORM.hiddenForClient"
        [disabled]="service.task?.isDeleted"
        *ngIf="!service?.storage?.Employee?.isClient"
      />
    </div>
  </div>
</div>
